/**
 * Chooses the provider for a mode. The only two modes are explicit:
 *   - `live`    → HTTP provider against the real API. A failure is an error;
 *                 nothing is substituted with fixture data.
 *   - `preview` → the fixture provider (screens that are demos, and tests).
 * There is no "live, but fixture if it fails" mode.
 */
import { createFixtureProvider, type FixtureOptions } from './fixtureProvider.ts';
import { createHttpProvider, type AiTransport } from './httpProvider.ts';
import type { AiProvider } from './provider.ts';

export type AiProviderMode =
  | { readonly mode: 'preview'; readonly fixture?: FixtureOptions }
  | {
      readonly mode: 'live';
      readonly slug: string;
      readonly transport: AiTransport;
      readonly timeoutMs?: number;
    };

export function selectProvider(config: AiProviderMode): AiProvider {
  if (config.mode === 'preview') return createFixtureProvider(config.fixture);
  return createHttpProvider({
    slug: config.slug,
    transport: config.transport,
    ...(config.timeoutMs !== undefined ? { timeoutMs: config.timeoutMs } : {}),
  });
}
